<template>
  <base-index
    ref="baseIndex"
    :columns="columns"
    :resourceName="resourceName"
    :pk="pk"
    :disabledFilterButton="false"
    :breadcrumbs="breadcrumbs"
    :disabledAddButton="isProvider && !permissionArticleEdit"
    :disableEdit="isProvider && !permissionArticleEdit"
  >
  </base-index>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      resourceName: "topics",
      pk: "id",
      columns: [
        {
          value: "id",
          text: "特集ページID",
          filter: true,
          width: '80px'
        },
        {
          value: "title",
          text: "特集ページ名",
          filter: true,
          width: 80
        },
        {
          value: "maker_name",
          text: "メーカー名",
          filter: true,
          width: 80
        },
        {
          value: "publish_from",
          text: "公開期間 from",
          filter: true,
          type: "date",
          width: 80
        },
        {
          value: "publish_to",
          text: "公開期間 to",
          filter: true,
          type: "date",
          width: 80
        },
        {
          value: "for_paid_user",
          text: "有料会員向けフラグ",
          filter: true,
          width: 80,
          type: 'select',
          optionType: "common/for_paid_users"
        },
        {
          value: "published",
          text: "公開/非公開",
          filter: true,
          width: 80,
          type: 'select',
          optionType: "common/publish"
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "特集ページ一覧",
          disabled: true
        }
      ];
    },
    permissionArticleEdit() {
      return this.$store.getters[`auth/permissionArticleEdit`];
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  }
};
</script>
